"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _victory = require("victory");

var _victoryTheme = require("../theme/victoryTheme");

var _colors = _interopRequireDefault(require("../theme/colors"));

var _ChartTitle = _interopRequireDefault(require("./ChartTitle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var OONILogoWordmarkHoriz = function OONILogoWordmarkHoriz(props) {
  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 698.19 196.824"
  }, props), _react.default.createElement("path", {
    d: "M248.75 103.262c0-16.843 5.511-30.388 16.536-40.643 11.078-10.254 25.75-15.38 44.02-15.38 7.456 0 14.405 1.008 20.851 3.028 6.496 1.965 12.196 4.834 17.096 8.606 7.136 5.473 12.594 12.061 16.378 19.765 3.781 7.704 5.67 16.071 5.67 25.102 0 17.001-5.725 30.949-17.176 41.839-11.395 10.84-26.123 16.257-44.176 16.257-17.844 0-32.168-5.365-42.982-16.096-10.811-10.732-16.217-24.891-16.217-42.478zm60.395-43.751c-8.521 0-15.312 4.143-20.37 12.433-5.008 8.287-7.511 19.524-7.511 33.708 0 13.337 2.61 24.122 7.831 32.356 5.272 8.234 12.01 12.352 20.211 12.352s14.806-4.196 19.811-12.591c5.008-8.395 7.511-19.684 7.511-33.869 0-13.496-2.531-24.252-7.589-32.276-5.007-8.075-11.637-12.113-19.894-12.113zm72.428 43.751c0-16.843 5.514-30.388 16.536-40.643 11.078-10.254 25.753-15.38 44.02-15.38 7.456 0 14.405 1.008 20.851 3.028 6.496 1.965 12.196 4.834 17.096 8.606 7.136 5.473 12.597 12.061 16.378 19.765s5.672 16.071 5.672 25.102c0 17.001-5.725 30.949-17.176 41.839-11.398 10.84-26.123 16.257-44.178 16.257-17.841 0-32.168-5.365-42.979-16.096-10.815-10.732-16.22-24.891-16.22-42.478zm60.397-43.751c-8.521 0-15.312 4.143-20.373 12.433-5.008 8.287-7.509 19.524-7.509 33.708 0 13.337 2.61 24.122 7.829 32.356 5.272 8.234 12.01 12.352 20.211 12.352s14.806-4.196 19.813-12.591c5.005-8.395 7.509-19.684 7.509-33.869 0-13.496-2.529-24.252-7.589-32.276-5.007-8.075-11.636-12.113-19.891-12.113zm69.791 99.536v-9.164l9.985-.957 3.116-3.108V62.062l-2.156-2.392-10.944-1.194v-8.928h46.176v4.385l46.894 72.599V62.778l-2.877-3.108-10.705-1.194v-8.928h41.463v8.928l-9.667 1.194-3.116 3.108v96.269h-26.043l-54.165-83.198v69.968l2.315 3.108 10.944.957v9.164h-41.22zm128.029 0v-9.483l11.824-.638 2.557-3.108V62.062l-2.557-2.392-11.824-.636v-9.485h58.4v9.485l-12.066.636-2.635 2.392v83.756l2.635 3.108 12.065.638v9.483H639.79z"
  }), _react.default.createElement("path", {
    fill: "#8DD8F8",
    d: "M98.41.002c54.35 0 98.41 44.06 98.41 98.41s-44.06 98.41-98.41 98.41S0 152.762 0 98.412 44.06.002 98.41.002"
  }), _react.default.createElement("path", {
    fill: "#0588CB",
    d: "M71.633 76.016c6.914 6.75 8.476 13.023 5.642 18.678-3.067 6.119-10.138 9.427-21.759 9.524-10.016.085-12.725-4.89-14.757-7.749-3.896-5.481-1.879-12.131 1.775-16.401 4.438-5.187 7.715-5.635 11.319-3.694 1.934 1.041 4.792 3.468 4.857 7.891.038 2.634-1.744 6.715-1.744 7.232 0 .517.42.839.872.646.453-.194 4.081-2.114 6.135-4.746 1.837-2.355 3.809-10.913 3.423-12.011-.388-1.097-3.18-3.38-3.373-4.608-.115-.729-.201-1.661-.544-2.426-.234-.522-.876-1.002-1.216-1.264-.839-.647-3.035.161-3.939-.969-.774-.968-1.097-3.002-2.131-3.26-.469-.118-1.372-.307-2.197-.139-1.186.242-2.077.958-3.001.848-1.289-.151-2.389-2.196-4.133-2.066-1.734.128-3.938 3.099-6.328 5.682-2.389 2.583-6.631 5.846-9.622 11.107-2.168 3.814-3.939 8.33-3.035 14.723.904 6.393 2.479 10.701 7.62 15.4 5.288 4.834 9.557 6.231 12.72 7.33 3.165 1.097 5.359 2.122 8.782 2.228 1.18.036 3.691.114 4.525.025 2.109-.226 1.68-1.154 3.644-1.478 7.651-1.259 13.099-5.253 16.411-8.626.842-.858 3.053-3.218 3.465-3.625.103.588.135 2.474.068 2.964-.459 3.359-2.555 5.239-5.913 7.03-4.795 2.557-11.756 6.315-16.53 9.656-4.416 3.092-8.31 6.096-9.68 11.028-1.37 4.931-1.095 7.762.411 11.164 1.375 3.103 3.881 6.415 8.081 8.835 3.475 2.002 6.516 3.762 9.868 5.483 2.307 1.185 6.342 3.191 5.976 7.393-.37 4.259-3.127 6.513-4.999 7.329-3.215 1.402-7.62 1.768-7.809 1.918-.332.265 3.835 3.787 7.032 3.766 3.492-.022 4.73-.257 7.967-1.392 2.816-.987 4.042-3.447 4.498-3.539.457-.092 1.125-.037 1.735-.48.595-.432 2.488-1.895 2.716-2.762.228-.868.275-2.328.503-3.105.228-.776 1.142-3.401 1.187-4.816.046-1.416.412-4.658-.856-6.519-1.051-1.542-.503-2.352-1.382-3.185-.146-.139-.884-1.116-1.559-1.369-.874-.327-1.33-.041-1.956-.389-1-.556-2.195-4.303-3.638-4.408a5.732 5.732 0 0 0-1.671.122c-1.187.286-6.383.421-7.316.062-1.444-.556-6.153-3.561-5.753-7.899.344-3.727 2.999-6.263 6.597-7.581 3.214-1.176 4.338-1.073 6.53-2.123 2.161-1.035 3.677-2.351 5.32-3.218 1.643-.868 3.869-1.906 5.558-3.322.963-.807 1.929-1.722 2.841-2.87.781-.98 2.274-3.641 3.868-4.961 2.18 3.333 4.31 6.268 5.883 8.092 3.994 4.634 9.451 7.454 12.008 9.052 2.557 1.597 8.423 5.995 10.936 9.51 2.694 3.766 1.46 8.926-.024 10.889-1.284 1.701-4.2 3.905-8.218 3.813-4.298-.097-8.415-1.861-10.935-5.114-2.511-3.243-3.49-9.329-1.347-10.935 2.304-1.727 4.561-.904 5.981-.731 1.112.136 2.169-.457 2.352-1.37.182-.913-.114-2.01-1.347-2.968-.654-.509-1.858-1.352-3.518-1.331-.91.011-2.626.452-4.952.371-2.47-.086-4.903.178-7.137 2.244-1.837 1.701-2.892 3.043-3.579 5.172-.262.81.055 2.552-.054 3.588-.109 1.047-.541 1.867-.549 2.673-.013 1.198.183 2.664.456 4.095.304 1.593.883 3.434 1.6 5.063.293.667.529 1.581.906 1.986.458.493 1.332 1.003 2.162 1.812 1.57 1.531 3.39 3.508 4.825 4.076 1.782.706 5.388-.526 6.393-.206 1.004.319 2.294 1.892 3.846 1.847 1.553-.045 11.067-.493 14.349-1.802 4.101-1.637 11.174-6.144 12.565-12.417 1.714-7.735-1.535-13.028-4.797-16.899-4.027-4.78-11.582-10.954-17.282-15.044-3.265-2.342-4.503-4.124-5.766-6.251-.959-1.616-1.976-4.346-1.466-6.85 2.349 1.23 5.705 5.06 6.687 6.283 1.265 1.574 2.877 2.531 4.123 3.143 1.103.542 2.481.231 3.531.414 1.05.182.298 1.042 2.17 1.682 1.873.639 10.149 2.169 12.141 2.099.814-.029 1.904-.659 3.191-1.063 1.233-.387 3.341-.56 9.195-2.847 8.028-3.136 11.402-8.251 14.115-14.367 2.713-6.116.876-13.926-.707-17.475s-4.688-8.259-7.885-13.145c-3.196-4.886-7.202-9.873-5.416-19.887s9.43-13.085 10.516-14.925c.869-1.473-1.717-2.963-2.362-3.27-.782-.371-1.633-.66-3.687-.751a4.234 4.234 0 0 0-.373-.002c-1.811.065-2.775 1.202-3.521 1.452-.809.271-4.355.056-4.846.158-.537.112-1.479 1.247-1.681 1.536-.352.509-.081.636-.583 1.687-.503 1.05-4.085 4.038-5.066 5.901-.526.998.064 3.062-.576 4.431-.639 1.37-2.557 1.303-2.965 2.805-.3 1.105.274 4.655-.21 6.387-.501 1.795-1.54.986-1.605 2.816-.092 2.579 4.469 6.692 5.245 7.879.776 1.188 1.088 1.887 2.048 4.056 1.071 2.421 2.512 3.93 3.597 5.16s4.071 3.115 4.843 4.433c.428.733-.038 2.134.252 3.052.274.868 1.058 1.628 2.29 3.409 1.233 1.78.82 6.414-.295 9.215-1.115 2.802-4.153 6.514-9.35 7.972-5.197 1.458-18.246.265-23.472-13.446-2.403-6.306-1.3-13.684 4.315-19.488 5.614-5.804 9.803-14.682 9.816-23.929 0-19.619-16.652-35.523-36.556-35.523S60.911 31.205 60.911 50.824c.008 9.415 3.808 18.442 10.722 25.192z"
  }), _react.default.createElement("path", {
    fill: "#FFF",
    d: "M91.531 36.141c9.749 0 17.654 7.903 17.654 17.654 0 9.749-7.904 17.653-17.654 17.653s-17.654-7.903-17.654-17.653 7.905-17.654 17.654-17.654"
  }), _react.default.createElement("path", {
    fill: "#0588CB",
    d: "M89.243 52.278a4.04 4.04 0 1 1 0 8.081 4.04 4.04 0 0 1 0-8.081"
  }));
};

var colorScale = [_colors.default.palette.blue5, _colors.default.palette.pink6, _colors.default.palette.orange4, _colors.default.palette.lime3, _colors.default.palette.violet8];
var width = 400;
var height = 400;
var padding = {
  top: 80,
  bottom: 80,
  right: 80,
  left: 80
};

var radiansToDegrees = function radiansToDegrees(radians) {
  return radians * (180 / Math.PI);
};

var radius = Math.min(width - padding.left - padding.right, height - padding.top - padding.bottom) / 2;
var offsetWidth = (radius + padding.left + (width - radius - padding.right)) / 2;
var offsetHeight = (radius + padding.top + (height - radius - padding.bottom)) / 2;
var origin = {
  x: offsetWidth,
  y: offsetHeight
};

var centroidOffset = function centroidOffset(x1, y1, d) {
  /*
  We take the line going from the center of the pie and the coordinates x1 and y1.
  
  We then solve the second degree equantion system by x and y in order to
  determine which point is on that line and at distance d from (x1, y1).
  
  Based on the result we then figure out which solution is the correct one we
  need, based on whether or not it falls inside of the pie chart or not.
  */
  var m = (y1 - origin.y) / (x1 - origin.x);
  var q = -1 * m * origin.x + origin.y;
  var a = 1 + m * m;
  var b = 2 * m * q - 2 * x1 - 2 * y1 * m;
  var c = Math.pow(q - y1, 2) + x1 * x1 - d * d;
  var solution = {
    x1: (-1 * b + Math.sqrt(b * b - 4 * a * c)) / (2 * a),
    x2: (-1 * b - Math.sqrt(b * b - 4 * a * c)) / (2 * a)
  };
  solution.y1 = m * solution.x1 + q;
  solution.y2 = m * solution.x2 + q;

  if (radius * radius > Math.pow(solution.x1 - origin.x, 2) + Math.pow(solution.y1 - origin.y, 2)) {
    solution.x = solution.x2;
    solution.y = solution.y2;
    solution.direction = 'left';
  } else {
    solution.x = solution.x1;
    solution.y = solution.y1;
    solution.direction = 'right';
  }

  return solution;
};

var PieLabelComponent = function PieLabelComponent(props) {
  var x = props.x,
      y = props.y,
      slice = props.slice;
  var startAngle = radiansToDegrees(slice.startAngle);
  var endAngle = radiansToDegrees(slice.endAngle);
  var dotX = x,
      dotY = y,
      textX = x,
      textY = y,
      textDY = 0; // const centerAngle = startAngle + (endAngle - startAngle) / 2

  var sol = centroidOffset(x, y, 60);
  textX = sol.x - 30;
  textY = sol.y;
  var lineX = sol.x - 100,
      lineY = sol.y;

  if (sol.direction === 'right') {
    lineX = sol.x + 100;
  }

  var path = "M ".concat(x, " ").concat(y, " L ").concat(sol.x, " ").concat(sol.y, " L ").concat(lineX, " ").concat(lineY);
  var textStyle = Object.assign({}, _victoryTheme.baseLabelStyles, {
    fontSize: '14px'
  }); // Get the percentage by converting the angles from radiants to a percentage

  var percentage = Math.round((endAngle - startAngle) / 360 * 100);
  return _react.default.createElement("g", null, _react.default.createElement("path", {
    stroke: "black",
    fill: "none",
    d: path
  }), _react.default.createElement("text", {
    style: textStyle,
    textAnchor: props.textAnchor,
    x: textX,
    y: textY,
    dy: textDY
  }, props.text), _react.default.createElement("text", {
    style: textStyle,
    textAnchor: props.textAnchor,
    x: textX,
    y: textY,
    dy: textDY + 20
  }, percentage, "%"), _react.default.createElement("circle", {
    cx: dotX,
    cy: dotY,
    r: "2"
  }));
};

PieLabelComponent.propTypes = {
  x: _propTypes.default.number,
  y: _propTypes.default.number,
  slice: _propTypes.default.shape({
    startAngle: _propTypes.default.number,
    endAngle: _propTypes.default.number
  }),
  textAnchor: _propTypes.default.string,
  text: _propTypes.default.string
};

var PieChart =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PieChart, _React$Component);

  function PieChart() {
    _classCallCheck(this, PieChart);

    return _possibleConstructorReturn(this, _getPrototypeOf(PieChart).apply(this, arguments));
  }

  _createClass(PieChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          title = _this$props.title,
          subtitle = _this$props.subtitle;
      return _react.default.createElement("svg", {
        width: 400,
        height: 400
      }, _react.default.createElement(_ChartTitle.default, {
        text: title
      }), _react.default.createElement(_ChartTitle.default, {
        subtitle: true,
        text: subtitle
      }), _react.default.createElement("g", {
        transform: "translate(50, 0)"
      }, _react.default.createElement(_victory.VictoryPie, {
        padding: padding,
        width: width,
        height: width,
        innerRadius: 50,
        colorScale: colorScale,
        labelRadius: 80,
        labelComponent: _react.default.createElement(PieLabelComponent, null),
        data: data
      })), _react.default.createElement("g", {
        transform: "translate(25, 250)"
      }, _react.default.createElement(OONILogoWordmarkHoriz, {
        width: 100
      })));
    }
  }]);

  return PieChart;
}(_react.default.Component);

PieChart.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.object),
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string
};
var _default = PieChart;
exports.default = _default;